import React, {Component} from 'react';
import SelectArrayInput from '../components/SelectArrayInput'
import { getPackageTemplates } from '../restClient';

class PackageTemplatesSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      packageTemplates: []
    };
  }

  componentDidMount() {
    getPackageTemplates().then((result = []) => {
      const packageTemplates = result.map(item => ({
        id: item.productIdentifier,
        name: item.productIdentifier,
      }))
      this.setState((prevState) => ({
        ...prevState,
        packageTemplates,
      }));
    })
  }

  render() {
    return <SelectArrayInput options={{ fullWidth: true }} choices={this.state.packageTemplates} allowEmpty={false} {...this.props} />
  }
}

PackageTemplatesSelect.defaultProps = {
  addField: true,
  options: {},
};

export default PackageTemplatesSelect;



// WEBPACK FOOTER //
// ./src/components/packageTemplatesSelect.js